<template>
        <section class="page-section bg-light" id="bar">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">UNSER LOKAL</h2>
                    <h3 class="section-subheading text-muted">besteht aus drei gewölbten, alten Weinkellern. In unseren stilvoll dekorierten Räumen fühlen sich junge wie auch ältere Gäste wohl. Jederman kann bei Musik gemütliche Stunden verbringen und seinen Alltag hinter sich lassen. Die originelle Dekoration und das Ambiente laden zum Verweilen ein.</h3>
                </div>
            </div>

            <div id="portfolio">
                <div class="container-fluid p-0">
                    <div class="row no-gutters">
                        <div class="col-lg-4 col-sm-6"  v-for="(obj, key) in barJSON" :key=key>
                            <a class="portfolio-box">
                                    <img class="img-fluid" :src="obj.img" alt="" />
                            </a>
                            <div class="portfolio-caption">
                                <div class="portfolio-caption-heading">{{ obj.title }}</div>
                                <!-- <div class="portfolio-caption-subheading text-muted">Illustration</div> -->
                            </div>
                                <!-- <div class="portfolio-box-caption">
                                    <div class="project-category text-white-50">Bar Barriere</div>
                                    <div class="project-name text-white-50">{{ obj.title }}</div>
                                </div> -->
                            
                        </div>
                    </div>
                </div>
            </div>
        </section> 
</template>

<script>
export default {
    data: () => ({
        barJSON: [
            {
                img: require('../assets/img/bar/1.jpg'),
                caption: 'Illustration',
                title: 'Bar Barriere'
            },
            {
                img: require('../assets/img/bar/2.jpg'),
                caption: 'Illustration',
                title: 'Gartenwirtschaft'
            },
            {
                img: require('../assets/img/bar/3.jpg'),
                caption: 'Illustration',
                title: 'Stammtischrundi'
            },
            {
                img: require('../assets/img/bar/4.jpg'),
                caption: 'Illustration',
                title: 'gemütliches Beisammensein'
            },
            {
                img: require('../assets/img/bar/5.jpg'),
                caption: 'Illustration',
                title: 'Bei uns sind auch Kinder herzlich willkommen!'
            },
            {
                img: require('../assets/img/bar/6.jpg'),
                caption: 'Next',
                title: 'Wir sind für alle da.'
            }
        ]

    })
    
}
</script>

<style>

 
.portfolio-caption-heading {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.text-muted {
    color: #6c757d !important;
}
</style>